module.exports = __webpack_public_path__ + "static/img/header-store-l.e2cfbff.png";